"use strict";

var cov_o1n7oj56u = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\book\\Book.js";
  var hash = "47f556a25505564b1a4fa358a25afff1d4a9b84e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\book\\Book.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 29
        }
      },
      "2": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 93
        }
      },
      "3": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 35,
          column: 6
        }
      },
      "4": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      },
      "5": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 61,
          column: 2
        }
      },
      "6": {
        start: {
          line: 63,
          column: 18
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "7": {
        start: {
          line: 63,
          column: 39
        },
        end: {
          line: 68,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 20
          },
          end: {
            line: 10,
            column: 21
          }
        },
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 63,
            column: 29
          },
          end: {
            line: 63,
            column: 30
          }
        },
        loc: {
          start: {
            line: 63,
            column: 39
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 63
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 39
          },
          end: {
            line: 39,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 39
          },
          end: {
            line: 39,
            column: 48
          }
        }, {
          start: {
            line: 39,
            column: 52
          },
          end: {
            line: 39,
            column: 58
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "47f556a25505564b1a4fa358a25afff1d4a9b84e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Book = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _ = require("..");

cov_o1n7oj56u.s[0]++;

var Book = function Book(_ref) {
  var _ref$book = _ref.book,
      headers = _ref$book.headers,
      chapters = _ref$book.chapters,
      paragraphs = _ref.paragraphs,
      renderOffscreen = _ref.renderOffscreen,
      showUnsupported = _ref.showUnsupported,
      direction = _ref.direction,
      disableWordPopover = _ref.disableWordPopover;
  cov_o1n7oj56u.f[0]++;
  var classes = (cov_o1n7oj56u.s[1]++, useStyles());
  var bookHeaders = (cov_o1n7oj56u.s[2]++, _react.default.createElement(_.BookHeaders, {
    headers: headers,
    direction: direction,
    showUnsupported: showUnsupported
  }));

  var _chapters = (cov_o1n7oj56u.s[3]++, _react.default.createElement(_.Chapters, {
    chapters: chapters,
    paragraphs: paragraphs,
    renderOffscreen: renderOffscreen,
    showUnsupported: showUnsupported,
    direction: direction,
    disableWordPopover: disableWordPopover
  }));

  cov_o1n7oj56u.s[4]++;
  return _react.default.createElement("div", {
    className: classes.book,
    dir: (cov_o1n7oj56u.b[0][0]++, direction) || (cov_o1n7oj56u.b[0][1]++, 'auto')
  }, bookHeaders, _chapters);
};

exports.Book = Book;
cov_o1n7oj56u.s[5]++;
Book.propTypes = {
  book: _propTypes.default.shape({
    headers: _propTypes.default.array.isRequired,
    chapters: _propTypes.default.object.isRequired
  }),

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool,

  /** bypass rendering only when visible */
  renderOffscreen: _propTypes.default.bool,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** override text direction detection */
  direction: _propTypes.default.string,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var useStyles = (cov_o1n7oj56u.s[6]++, (0, _styles.makeStyles)(function (theme) {
  cov_o1n7oj56u.f[1]++;
  cov_o1n7oj56u.s[7]++;
  return {
    book: {},
    bookName: {}
  };
}));
var _default = Book;
exports.default = _default;